module.exports = __webpack_public_path__ + "img/sib.4abac550.jpg";